<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item" v-if="checkClaim(CAN_VIEW_PARTS)">
        <router-link :to="usersLink" class="nav-link">
          <i class="fa fa-user mr-1"/>Users
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_VIEW_INVENTORY)">
        <router-link :to="rolesLink" class="nav-link">
          <i class="fa fa-lock mr-1"/>Roles
        </router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    metaInfo: () => ({
      title: 'New Erp',
    }),
    data() {
      return {};
    },
    computed: {
      ...mapGetters('userMgmt', ['lastOpenedTab',
        'usersLink',
        'rolesLink'
      ]),
    },
    methods: {
      ...mapMutations('userMgmt', ['setItem']),
    },
    watch: {},
    mounted() {
      if (!this.lastOpenedTab) {
        this.setItem({ resource: 'usersLink', payload: this.usersLink });
        this.setItem({ resource: 'lastOpenedTab', payload: this.usersLink });
      }
      if (this.$route.meta.controlLink) {
        this.setItem({ resource: this.$route.meta.controlLink, payload: this.$route.fullPath });
        this.setItem({ resource: 'lastOpenedTab', payload: this.$route.fullPath });
      }
    },
  };
</script>

<style scoped>
.new-offer-button {
  right: 10px;
  position: absolute;
  top: 4px;
}
</style>
